// Nuxt UI 元件的外觀覆寫。
//
// 顏色一律用 MomentX design tokens 的 mx- utility（見 assets/css/tokens/）。
// token 本身會隨深淺色翻轉，所以這裡不需要再為每個狀態各寫一份 dark: 版本。
export default defineAppConfig({
  ui: {
    modal: {
      slots: {
        overlay: 'bg-mx-scrim',
        content: 'bg-mx-surface-raised text-mx-ink',
      },
    },
    // 進度條軌道：預設的 bg-accented 在深色模式等於卡片底色（兩者都是 #1b2034），軌道會整條消失。
    // 淺色維持 mx-line（與原本同色），深色改用 mx-line-strong 才看得出軌道。
    progress: {
      slots: {
        base: 'relative overflow-hidden rounded-full bg-mx-line dark:bg-mx-line-strong',
      },
    },
    button: {
      compoundVariants: [
        // 主要按鈕：品牌青填色配白字，hover 往深的走
        {
          color: 'primary',
          variant: 'solid',
          class:
            'bg-mx-brand text-mx-on-brand hover:bg-mx-brand-hover disabled:bg-mx-surface-disabled disabled:text-mx-ink-disabled',
        },
        // 主色外框：hover 時反轉成實心
        {
          color: 'primary',
          variant: 'outline',
          class:
            'bg-mx-surface text-mx-brand-text ring-mx-brand hover:bg-mx-brand hover:text-mx-on-brand disabled:bg-mx-surface disabled:text-mx-ink-disabled disabled:ring-mx-line',
        },
        // 中性實心：深墨底，深色模式自動變成淺底
        {
          color: 'neutral',
          variant: 'solid',
          class:
            'bg-mx-ink text-mx-surface hover:bg-mx-ink-secondary disabled:bg-mx-surface-disabled disabled:text-mx-ink-disabled',
        },
        {
          color: 'neutral',
          variant: 'outline',
          class:
            'bg-mx-surface text-mx-ink-secondary ring-mx-line hover:bg-mx-surface-hover disabled:bg-mx-surface disabled:text-mx-ink-disabled disabled:ring-mx-line',
        },
        {
          color: 'neutral',
          variant: 'ghost',
          class: 'bg-transparent text-mx-ink-secondary hover:bg-mx-surface-hover disabled:text-mx-ink-disabled',
        },
        // 輔色：統一色板之後與主色相同
        {
          color: 'secondary',
          variant: 'solid',
          class:
            'bg-mx-brand text-mx-on-brand hover:bg-mx-brand-hover disabled:bg-mx-surface-disabled disabled:text-mx-ink-disabled',
        },
        // 危險動作
        {
          color: 'error',
          variant: 'solid',
          class:
            'bg-mx-danger text-mx-on-danger hover:bg-mx-danger-strong disabled:bg-mx-surface-disabled disabled:text-mx-ink-disabled',
        },
      ],
    },
    input: {
      compoundVariants: [
        {
          class:
            'bg-mx-surface text-mx-ink ring-mx-line-strong focus:ring-mx-brand disabled:bg-mx-surface-disabled disabled:text-mx-ink-disabled disabled:ring-mx-line',
        },
      ],
    },
    textarea: {
      compoundVariants: [
        {
          class:
            'bg-mx-surface text-mx-ink ring-mx-line-strong focus:ring-mx-brand disabled:bg-mx-surface-disabled disabled:text-mx-ink-disabled disabled:ring-mx-line',
        },
      ],
    },
    formField: {
      slots: {
        label: 'text-mx-ink',
        description: 'text-mx-ink-secondary',
      },
    },
    card: {
      slots: {
        body: 'bg-mx-surface rounded-lg text-mx-ink',
        footer: 'bg-mx-surface rounded-b-lg',
      },
    },
    switch: {
      slots: {
        base: 'data-[state=unchecked]:bg-mx-line-strong',
        thumb: 'bg-mx-surface',
      },
    },
    badge: {
      compoundVariants: [
        {
          color: 'neutral',
          variant: 'soft',
          class: 'bg-mx-surface-hover text-mx-ink-secondary',
        },
      ],
    },
    dropdownMenu: {
      slots: {
        item: 'items-center',
      },
    },
  },
});
